module.exports = __webpack_public_path__ + "img/stuff-logo.027ab79d.svg";